import type {
  FieldRef,
  SeasonRef,
  YieldAsset,
  YieldDataByField,
} from '../components/LayerStatistics/sources/LayerStatisticsSourceTypes';

export const findActiveYieldAsset = (
  yieldData: YieldDataByField | null,
  selectedField: FieldRef | null,
  date: string | null,
  selectedSeason: SeasonRef | null
): YieldAsset | null => {
  if (!yieldData || !selectedField || !selectedSeason) {
    return null;
  }

  const fieldYieldData = yieldData[selectedField.fieldId];
  if (!fieldYieldData) {
    return null;
  }

  return (
    fieldYieldData.find(
      (item: YieldAsset) => item.date === date && item.seasonId === selectedSeason.id
    ) ||
    fieldYieldData.find((item: YieldAsset) => item.seasonId === selectedSeason.id) ||
    null
  );
};
